import React from 'react';
import Icon from '@/components/ui/AppIcon';

const history = [
  { id: 'hist-001', action: 'Caramel Macchiato Grande', date: '17 Tem 2026', stars: +18, type: 'earn', store: 'Taksim' },
  { id: 'hist-002', action: 'Ücretsiz İçecek Kullanıldı', date: '15 Tem 2026', stars: -200, type: 'redeem', store: 'Nişantaşı' },
  { id: 'hist-003', action: 'Vanilla Latte + Kruvasan', date: '14 Tem 2026', stars: +25, type: 'earn', store: 'Beşiktaş' },
  { id: 'hist-004', action: 'Çift Yıldız Günü Bonusu', date: '13 Tem 2026', stars: +40, type: 'bonus', store: 'Kadıköy' },
  { id: 'hist-005', action: 'Cold Brew Venti', date: '12 Tem 2026', stars: +10, type: 'earn', store: 'Taksim' },
  { id: 'hist-006', action: 'Sabah Kahvesi Görevi', date: '11 Tem 2026', stars: +50, type: 'challenge', store: '' },
  { id: 'hist-007', action: 'Frappuccino Caramel', date: '10 Tem 2026', stars: +10, type: 'earn', store: 'Nişantaşı' },
];

export default function StarsHistory() {
  return (
    <div className="px-4 pb-4">
      <h2 className="text-foreground font-bold text-base mb-3">Yıldız Geçmişi</h2>
      <div className="bg-card rounded-2xl card-shadow overflow-hidden">
        {history?.map((item, idx) => (
          <div
            key={item?.id}
            className={`flex items-center gap-3 px-4 py-3 ${idx < history?.length - 1 ? 'border-b border-border' : ''}`}
          >
            <div
              className={`w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0 ${
                item?.type === 'redeem' ?'bg-red-100'
                  : item?.type === 'challenge' ?'bg-accent'
                  : item?.type === 'bonus' ?'bg-gold-light' :'bg-muted'
              }`}
            >
              {item?.type === 'redeem' ? (
                <Icon name="GiftIcon" size={16} className="text-red-500" />
              ) : item?.type === 'challenge' ? (
                <Icon name="TrophyIcon" size={16} className="text-primary" />
              ) : item?.type === 'bonus' ? (
                <Icon name="BoltIcon" size={16} className="text-gold" />
              ) : (
                <Icon name="ShoppingBagIcon" size={16} className="text-muted-foreground" />
              )}
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-foreground font-semibold text-sm truncate">{item?.action}</p>
              <p className="text-muted-foreground text-xs">
                {item?.date}{item?.store && ` · ${item?.store}`}
              </p>
            </div>
            <span
              className={`font-bold text-sm font-tabular flex-shrink-0 ${
                item?.stars > 0 ? 'text-primary' : 'text-red-500'
              }`}
            >
              {item?.stars > 0 ? '+' : ''}{item?.stars} ★
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}